// extracted by mini-css-extract-plugin
export var editInput = "_iu-0";
export var editInputCompact = "_iu-2";
export var editInputLarge = "_iu-1";
export var editInputSmall = "_iu-3";